export const clientTheme = {
  backgroundColorOne: '#D9C5EF',
  backgroundColorTwo: '#EB9CA2',
  brandColor: '#E31837', // Coles red
}
